var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DataList',{attrs:{"title":"Типи Сервісів","resource":"service-types","columns":_vm.columns,"get-items-fn":_vm.getServiceTypes,"search-label":'Пошук за назвою типу сервіса'}})}
var staticRenderFns = []

export { render, staticRenderFns }